export type CatalogScope = {
  tenantId: string
  orgId: string
}

export function catalogScope (tenantId: string, orgId: string): CatalogScope | undefined {
  if (!tenantId || !orgId || tenantId === 'undefined' || orgId === 'undefined') {
    return undefined
  }

  return { tenantId, orgId }
}

export function catalogScopeKey (scope: CatalogScope): string {
  return `${scope.tenantId}-${scope.orgId}`
}

export function catalogScopeMatches (
  started: CatalogScope | undefined,
  current: CatalogScope | undefined,
): boolean {
  return started !== undefined
    && current !== undefined
    && started.tenantId === current.tenantId
    && started.orgId === current.orgId
}
